(function(){var t=document.getElementById('yhYouTrack');if(!t)return;var d=false,sx,sl;t.addEventListener('mousedown',function(e){d=true;t.classList.add('dragging');sx=e.pageX-t.offsetLeft;sl=t.scrollLeft;});document.addEventListener('mouseup',function(){d=false;t.classList.remove('dragging');});t.addEventListener('mousemove',function(e){if(!d)return;e.preventDefault();t.scrollLeft=sl-(e.pageX-t.offsetLeft-sx)*1.2;});})();
function yhYouShift(d){var t=document.getElementById('yhYouTrack');if(t)t.scrollBy({left:d*300,behavior:'smooth'});}
(function(){var g=document.getElementById('yhReviewsGrid');if(!g)return;var d=false,sx,sl;g.addEventListener('mousedown',function(e){d=true;g.classList.add('dragging');sx=e.pageX-g.offsetLeft;sl=g.scrollLeft;});document.addEventListener('mouseup',function(){d=false;g.classList.remove('dragging');});g.addEventListener('mousemove',function(e){if(!d)return;e.preventDefault();g.scrollLeft=sl-(e.pageX-g.offsetLeft-sx)*1.2;});})();
function yhFeatQty(d){var el=document.getElementById('yhFeatQtyVal');var v=parseInt(el.textContent)+d;if(v<1)v=1;el.textContent=v;}

function yhUpdateDrawer(sections){
  if(!sections||!sections['cart-drawer'])return;
  var parser=new DOMParser();
  var doc=parser.parseFromString(sections['cart-drawer'],'text/html');
  var maps=[['#CartDrawer-CartItems','#CartDrawer-CartItems'],['.ycd-footer','.ycd-footer'],['.ycd-title','.ycd-title']];
  maps.forEach(function(m){var n=doc.querySelector(m[0]);var e=document.querySelector(m[1]);if(n&&e)e.innerHTML=n.innerHTML;});
  var drawer=document.querySelector('cart-drawer');
  if(drawer){
    var itemCount=doc.querySelectorAll('.ycd-item').length;
    if(itemCount===0)drawer.classList.add('is-empty');else drawer.classList.remove('is-empty');
  }
}

function yhAddToCart(vid,qty){
  var drawer=document.querySelector('cart-drawer');
  if(drawer&&typeof drawer.open==='function'){drawer.open();}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:vid,quantity:qty||1,sections:['cart-drawer'],sections_url:window.location.pathname})
  })
  .then(function(r){return r.json();})
  .then(function(data){
    yhUpdateDrawer(data.sections);
    var t=document.getElementById('yhToast');
    if(t){t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2500);}
  })
  .catch(function(){
    var t=document.getElementById('yhToast');
    if(t){t.textContent='Erreur, réessayez';t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2500);}
  });
}

// Suppression via poubelle — écouteur délégué global
document.addEventListener('click',function(e){
  var btn=e.target.closest('.ycd-remove,cart-remove-button button');
  if(!btn)return;
  e.preventDefault();e.stopPropagation();
  var removeEl=btn.closest('cart-remove-button')||btn;
  var lineIndex=removeEl.getAttribute('data-index')||btn.getAttribute('data-index');
  var variantId=btn.getAttribute('data-variant-id');
  if(!lineIndex&&!variantId)return;
  var body=lineIndex
    ?{line:parseInt(lineIndex),quantity:0,sections:['cart-drawer'],sections_url:window.location.pathname}
    :{id:parseInt(variantId),quantity:0,sections:['cart-drawer'],sections_url:window.location.pathname};
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify(body)
  })
  .then(function(r){return r.json();})
  .then(function(data){yhUpdateDrawer(data.sections);})
  .catch(function(){console.error('Erreur suppression panier');});
},true);